import { LoadingButton } from "@mui/lab";
import { Button, Divider, Stack } from "@mui/material";

import {
  postConsultationFee,
  putConsultationFee,
} from "../../../../Api/Signin/Transaction.Api";
import { Theme } from "../../../../Style/Theme";
import useLoadingState from "../../../../Utils/Hooks/useLodingState";
import { NumberInputType3 } from "../../../atoms/Input/NumberInput";
import { Heading3 } from "../../../atoms/Typography/Heading/Heading";
import { Text8 } from "../../../atoms/Typography/Text/Text";

export const DcsEditField = ({
  control,
  isUpdate,
  reset,
  contentOptions,
  setError,
  setContentID,
  handleSubmit,
  loadConsultationFee,
  t,
  type,
}) => {
  const { startLoading, stopLoading, LoadingState } = useLoadingState();

  const consultationFeeAddHandler = async (e) => {
    try {
      let response;
      startLoading({ btnName: "add" });
      const fee = e.fee;
      const modeId = type === "online" ? 1 : 2;
       const data = {
        onlineConsultationFee:
          type === "online"
            ? {
                ...(contentOptions.id && { id: contentOptions.id }),
                value: fee,
                isActive: true,
                modeId: modeId,
              }
            : null,

        onsiteConsultationFee:
          type === "onsite"
            ? {
                ...(contentOptions.id && { id: contentOptions.id }),
                value: fee,
                isActive: true,
                modeId: modeId,
              }
            : null,
      };

      if (isUpdate) {
        response = await putConsultationFee(data);
      } else {
        response = await postConsultationFee(data);
      }

      if (response.type === 0) {
        reset();
        loadConsultationFee();
        setContentID({
          sceneID: 0,
          isUpdate: false,
          id: "",
        });
      } else {
        setError("fee", { message: response.message });
      }
      stopLoading({ btnName: "add" });
    } catch (exception) {
      console.log(exception);
      stopLoading({ btnName: "add" });
    }
  };

  return (
    <form onSubmit={handleSubmit(consultationFeeAddHandler)}>
      <Stack
        direction={"row"}
        marginTop={"16px"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        marginBottom={"16px"}
        width={"100%"}
      >
        <Stack justifyContent={"center"} width={"60%"} mt={2}>
          <Stack direction={"row"}>
            <Heading3
              text={`${
                type === "online" ? "Online" : "On-site"
              } maximun consultation Fee`}
            />
            <Heading3 text={"*"} color={Theme.palette.background.red} />
          </Stack>
          <Text8 text={t("glossary:consultation-rate:subject-goverment")} />
        </Stack>
        <NumberInputType3
          isSubmitForm={true}
          control={control}
          name={"fee"}
          fullWidth
          width={"40%"}
          placeholder={"Amount"}
        />
      </Stack>
      <Divider style={{ width: "100%", marginBottom: "16px" }} />
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"flex-end"}
      >
        <Button
          onClick={() => {
            reset();
            setContentID({
              sceneID: 0,
              isUpdate: false,
              id: "",
            });
          }}
          variant="LightBlueFontOnly"
          sx={{ maxHeight: "50px" }}
        >
          {t("common:action:cancel")}
        </Button>
        <LoadingButton
          loading={LoadingState.visible}
          type="submit"
          variant="primaryBlue"
          sx={{ maxHeight: "50px" }}
        >
          {isUpdate ? t("common:action:update") : t("common:action:add")}
        </LoadingButton>
      </Stack>
    </form>
  );
};
